// import { Marker } from "react-google-maps";
import React, { useEffect, useRef, useState } from "react";
import { ReactGoogleMap, ModalComponent } from "components/UiElement";
/* eslint-disable import/no-unresolved */
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Button } from "react-bootstrap";
import { Navigation, EffectFade } from "swiper/modules";
import AlbumModal from "components/UiElement/AlbumModel";
import MapCard from "../MapCard";

function MapSection({
  toggleClass,
  leftPadding,
  handleClose,
  locationList = [],
}) {
  const [center, setCenter] = useState({
    lat: parseFloat(locationList?.[0]?.lat),
    lng: parseFloat(locationList?.[0]?.long),
  });
  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const openImageModal = () => {
    setShowModal(!showModal);
  };
  const swiper = useSwiper();

  const swiperRef = useRef(null);
  const [locId, setLocId] = useState(0);
  // const [arrList, setArrList] = useState([]);
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const options = { minZoom: 2, maxZoom: 6 };

  // const handlePrev = () => {
  //   if (swiperRef.current && swiperRef.current.swiper) {
  //     swiperRef.current.swiper.slidePrev();
  //   }
  // };

  // const handleNext = () => {
  //   if (swiperRef.current && swiperRef.current.swiper) {
  //     swiperRef.current.swiper.slideNext();
  //   }
  // };

  const onHandleClose = () => {
    setShow(false);
    setDescription("");
  };

  const onHandleId = (id) => {
    setLocId(id);
    toggleClass();
  };

  useEffect(() => {
    if (locId) {
      let index = locationList.findIndex((item) => item?.id === locId);
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.slideTo(index);
      }
    }
  }, [locationList, locId]);

  useEffect(() => {
    if (currentItem) {
      setCenter({
        lat: parseFloat(currentItem.lat),
        lng: parseFloat(currentItem.long),
      });
    }
  }, [currentItem]);

  return (
    <>
      <div className="landmarkSec_left" style={{ paddingLeft: leftPadding }}>
        <div className="commonHead">
          <div className="commonHead_sub text-white">
            Click an image to view a timeless memory
          </div>
          <h2 className="commonHead_title text-white">Lifetime Journey </h2>
        </div>
        <div className="landmarkSec_box">
          <div className="timeLine timeLine-lg position-relative">
            <div className="landmarkSec_box-inner position-relative">
              <Swiper
                spaceBetween={20}
                ref={swiperRef}
                slidesPerView={1}
                // loop
                centeredSlides
                pagination={{
                  clickable: true,
                }}
                navigation={{
                  nextEl: ".next",
                  prevEl: ".prev",
                }}
                modules={[Navigation, EffectFade]}
                effect="fade"
                onSlideChange={(e) => {
                  setCurrentItem(locationList[e.realIndex]);
                }}
              >
                {locationList?.length > 0 &&
                  locationList?.map((item, index) => {
                    return (
                      <SwiperSlide key={index}>
                        <MapCard
                          handleClose={handleClose}
                          item={item}
                          index={index}
                          length={locationList?.length}
                          setShow={setShow}
                          setDescription={setDescription}
                          setData={setData}
                          openImageModal={openImageModal}
                          button={
                            <div className="flex-shrink-0 d-flex">
                              <div>
                                <Button
                                  type="button"
                                  className="btn me-2 me-lg-3 prev count_btn"
                                  onClick={() => {
                                    if (swiper) swiper?.slidePrev();
                                  }}
                                >
                                  <em className="icon-arrow-right count_btn_arrowLeft" />
                                </Button>
                              </div>
                              <div>
                                <Button
                                  type="button"
                                  className="btn next count_btn"
                                  onClick={() => {
                                    if (swiper) swiper?.slideNext();
                                  }}
                                >
                                  <em className="icon-arrow-right" />
                                </Button>
                              </div>
                            </div>
                          }
                        />
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
      <div className="landmarkSec_right">
        <div className="mapOverlay" />
        <ReactGoogleMap
          position={center}
          options={options}
          zoom={0}
          isMarker
          customMarkerIcon="http://localhost:6011/public/uploads/image/album-photo/05-1693547521618--1--1711540092332.jpg"
          locationList={locationList}
          onHandleId={onHandleId}
        />
      </div>

      <ModalComponent
        show={show}
        onHandleCancel={onHandleClose}
        title="Description"
        closeButton
        extraClassName="readMoreModal"
      >
        <div className="text-break">{description ? description : ""}</div>
      </ModalComponent>
      <AlbumModal
        handleCloseModal={handleCloseModal}
        setData={setData}
        data={data}
        showModal={showModal}
      />
    </>
  );
}

export default MapSection;
